import { CAREERS_PRESET } from "./careers";
import { CONTACT_PRESET } from "./contact";
import { LANDING_PRESET } from "./landing";
import { LEGAL_PRESET } from "./legal";
import { NEWS_PRESET } from "./news";
import { PATIENTS_PRESET } from "./patients";
import { PRODUCT_PRESET } from "./product";
import { STORY_PRESET } from "./story";
/**
 * Each opening is one of the prototype's authored compositions: its initial
 * shape, curve profile, palette and the steps it knows. `compose.ts` assembles a
 * page's composition from one of these plus the roles its blocks carry.
 */
export const RIBBON_OPENINGS_BY_ID = {
    strand: LANDING_PRESET,
    product: PRODUCT_PRESET,
    funnel: STORY_PRESET,
    "bent-left": PATIENTS_PRESET,
    "bent-right": NEWS_PRESET,
    field: CAREERS_PRESET,
    band: CONTACT_PRESET,
    diagonal: LEGAL_PRESET,
};
export function ribbonOpening(id) {
    return RIBBON_OPENINGS_BY_ID[id];
}
export { LANDING_PRESET, PRODUCT_PRESET, STORY_PRESET, PATIENTS_PRESET, NEWS_PRESET, CAREERS_PRESET, CONTACT_PRESET, LEGAL_PRESET, };
//# sourceMappingURL=index.js.map